// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"116":"5944ba60","327":"7e38c1a2","507":"56703634","927":"85afcbbc","952":"14dcee73"}[chunkId] + ".chunk.js";
};